
import {ref, toRef, watchEffect, watch, onMounted} from 'vue';
import { useStore } from 'vuex';
import { availableFinishes } from "VueInterfaces/ProductFamilyInterface";
import { Tooltips } from 'Modules/tooltips';

export default {
    name: "FinishesBar",
	props: {
		groupBy: {
			type: String,
			default: ''
		},
		finishes: {
			type: Array,
			default: () => [] as availableFinishes[]
		},
		translations: {
			type: Object,
			default: {},
		}
	},
    setup(props) {
	    const store = useStore();
		const hoveredName = ref('');
		const showWholesale = ref<boolean>(false);
	    const productFinishes = toRef(props, 'finishes');

		const setSelectedFinish = async (finish:availableFinishes) => {
			const baseUrl = window.location.href.split('?')[0];
			productFinishes.value.forEach((productFinish) => {
				productFinish.isSelected = false;
			});

			productFinishes.value.filter(item => item.name === finish.name)[0].isSelected = true;
			await store.commit('setSelectedFinish', finish);
			let newUrl = `${baseUrl}?selectedFinish=${productFinishes.value.filter(item => item.name === finish.name)[0].slug}`;
			//await console.log(store.state?.selectedFinish);
			window.history.replaceState({}, '', newUrl);
		};

	    const setInitialFinish = () => {
		    if(productFinishes.value.length) {
			    const defaultFinishSlug = "satin-nickel";
			    const selectedItem = productFinishes.value.filter(item => item.slug === defaultFinishSlug)[0];
			    const baseUrl = window.location.href.split('?')[0];
			    const queryParams = new URLSearchParams(window.location.search);
				let newUrl;

				//set satin nickel as the default finish
			    if (queryParams.has('selectedFinish')) {
				    const selectedFinishValue = queryParams.get('selectedFinish');
				    store.commit('setSelectedFinish', productFinishes.value.filter(item => item.slug === selectedFinishValue)[0]);
				    newUrl = `${baseUrl}?selectedFinish=${selectedFinishValue}`;
			    } else if (productFinishes.value.filter(item => item.slug === defaultFinishSlug).length) {
					store.commit('setSelectedFinish', selectedItem);
				    newUrl = `${baseUrl}?selectedFinish=${selectedItem.slug}`;
			    } else {
				    store.commit('setSelectedFinish', productFinishes.value[0]);
				    newUrl = `${baseUrl}?selectedFinish=${productFinishes.value[0].slug}`;
			    }

			    // Push the updated query to the URL
			    window.history.replaceState({}, '', newUrl);
		    } else {
			    store.commit('setSelectedFinish', {});
		    }
	    };

		const setTempName = (finish) => {
			hoveredName.value = finish.name;
		};

		const removeTempName = (finish) => {
			hoveredName.value = '';
		}

		onMounted(() => {
			window.addEventListener("load", () => {
				Tooltips.init();
			});
		});

	    watch(showWholesale, (newValue, oldValue) => {
		    store.commit('setShowWholesale', newValue);
	    });

	    watchEffect(() => {
		    setInitialFinish()
	    });

        return {
	        productFinishes,
	        showWholesale,
	        store,
	        setSelectedFinish,
	        setInitialFinish,
	        setTempName,
	        removeTempName,
	        hoveredName
        }
    }
}
